import type { IconData } from '@stacksjs/iconify-core'

export const ne1x1: IconData = {
  "body": "<path fill=\"#0db02b\" d=\"M0 0h512v512H0z\"/><path fill=\"#fff\" d=\"M0 0h512v341.3H0z\"/><path fill=\"#e05206\" d=\"M0 0h512v170.7H0z\"/><circle cx=\"256\" cy=\"256\" r=\"72.5\" fill=\"#e05206\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default ne1x1
